import React, { useContext, useState } from "react";
import {
  Drawer,
  Grid,
  IconButton,
  List,
  ListItemButton,
  Box,
  Divider,
  ListItemIcon,
  Avatar,
  Typography,
  Collapse,
  Toolbar,
  Menu,
  Tooltip,
  Button,
  MenuItem,
  Badge,
} from "@mui/material";
import "./MenuHeader.css";
import { useLocation, useNavigate } from "react-router-dom";
import Down from "@mui/icons-material/ArrowDropDownOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import DownArrow from "@mui/icons-material/KeyboardArrowDownRounded";
import Logo from "../../assets/images/CareSMS_Logo.png";
import UserSvg from "../../assets/svgs/user";
import LogoutSvg from "../../assets/svgs/LogoutSvg";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../../features/auth/authSlice";
import {
  useLogoutMutation,
  useMicrosoftLogoutMutation,
} from "../../features/auth/authApiSlice";
import { Wallet } from "@mui/icons-material";
import NotificationsModal from "../Modals/NotificationsModal";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { SocketContext } from "../../context/SocketProvider";
import { avatarName } from "../../utilities/resuseFunctions";
import classNames from "classnames";
import { SKORBOARD_URL } from "../../constants/endpoints";
import { selectUser, selectToken } from "../../features/auth/authSlice";
import { useGetUserMutation } from "../../features/user/userApiSlice";
import { useGetSsoTokenMutation } from "../../features/auth/authApiSlice";
import useMenuOptions from "./menuOptions";
import {
  useGetAllSharedReportsMutation,
  useGetAllSharedDashboardsMutation,
} from "../../features/report/reportApiSlice";
import { isSystemAdmin } from "../../utilities/roleChecks";

const settings = [
  {
    id: 1,
    name: "Account",
    icon: UserSvg,
    path: "/account",
  },
  {
    id: 2,
    name: "Sign Out",
    icon: LogoutSvg,
  },
];

const settingsCreator = [
  {
    id: 1,
    name: "Account",
    icon: UserSvg,
    path: "/account",
  },
  {
    id: 4,
    name: "User Management",
    icon: UserSvg,
    path: "/user-management",
  },
  {
    id: 5,
    name: "Role Management",
    icon: UserSvg,
    path: "/role-management",
  },
  {
    id: 3,
    name: "Billing",
    icon: Wallet,
    path: "/billing",
  },
  {
    id: 2,
    name: "Sign Out",
    icon: LogoutSvg,
  },
];

const MenuHeader = ({ user }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [listData, setListData] = useState([]);
  const [subListData, setSubListData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { notifications } = useContext(SocketContext);
  const currentUser = useSelector(selectUser);
  const token = useSelector(selectToken);
  const [getUser, { isLoading: userLoading }] = useGetUserMutation();
  const [getToken] = useGetSsoTokenMutation();
  const menuOptions = useMenuOptions();
  const [getAllSharedReport] = useGetAllSharedReportsMutation();
  const [getAllSharedDashboards] = useGetAllSharedDashboardsMutation();
  const [publishedReports, setPublishedReports] = React.useState([]);
  const [publishedDashboards, setPublishedDashboards] = React.useState([]);
  const [openSubMenus, setOpenSubMenus] = useState({});

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const menuOptionsWithShared = menuOptions.map((option) => {
    if (option.name === "Reporting & Analytics") {
      return {
        ...option,
        subSections: option.subSections.map((sub) => {
          if (sub.name === "Lucet Published Reports") {
            return {
              ...sub,
              subSections: publishedReports.map((report) => ({
                id: report.id,
                name: report.report?.name,
                path: `/reports/shared-reports/${report.id}`,
                access: true,
              })),
            };
          }
          if (sub.name === "Lucet Published Dashboards") {
            return {
              ...sub,
              subSections: publishedDashboards.map((dashboard) => ({
                id: dashboard.id,
                name: dashboard.dashboard?.name ?? dashboard.name,
                path: `/dashboards/shared-dashboards/${dashboard.id}`,
                access: true,
              })),
            };
          }
          return sub;
        }),
      };
    }
    return option;
  });

  React.useEffect(() => {
    try {
      const fetchPublishReports = async () => {
        if (!user?.organisation?.id) return;
        const result = await getAllSharedReport().unwrap();
        setPublishedReports(result?.data || []);
      };
      fetchPublishReports();
    } catch (err) {
      console.log(err?.data?.message);
    }
  }, [user?.organisation?.id]);

  React.useEffect(() => {
    try {
      const fetchPublishedDashboards = async () => {
        if (!user?.organisation?.id) return;
        const result = await getAllSharedDashboards().unwrap();
        setPublishedDashboards(result?.data || []);
      };
      fetchPublishedDashboards();
    } catch (err) {
      console.log(err?.data?.message);
    }
  }, [user?.organisation?.id]);

  const redirectToCareSMSBI = async () => {
    const form = document.createElement("form");
    try {
      const ssoResult = await getToken(user).unwrap();
      const ssoToken = ssoResult?.data;

      // SSO token from CareSMS backend

      // const token = getState().auth.token; // or from Redux/store/state/context

      form.method = "POST";
      form.action = `${SKORBOARD_URL}/auth/sso-login`;
      form.target = "_blank";

      const input1 = document.createElement("input");
      input1.type = "hidden";
      input1.name = "token";
      input1.value = token;

      const input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "ssoToken";
      input2.value = ssoToken;

      form.appendChild(input1);
      form.appendChild(input2);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (error) {
      console.log(error);
    }
  };

  const handleListItemClick = (path, name) => {
    if (name === "CareSMS-BI") {
      redirectToCareSMSBI();
      setDrawerOpen(false);
      return;
    }
    navigate(path);
    setDrawerOpen(false);
    toggleDrawer(false);
  };
  const list = () => (
    <Box sx={{ width: 350 }} role="presentation">
      <div className="p-2 mx-2 d-flex align-items-center">
        <img src={Logo} alt="logo" className="logo" />
      </div>
      <Divider />
      <List>
        {menuOptionsWithShared
          .filter((option) => {
            if (
              user?.details?.role === 2 &&
              option.name === "Reporting & Analytics"
            ) {
              return false;
            }

            if (
              user?.organisation?.id == 47 &&
              option.name == "Data Management"
            ) {
              const caretagsIndex = option.subSections.findIndex(
                (e) => e?.name === "Caretags"
              );
              if (caretagsIndex !== -1) {
                option.subSections.splice(caretagsIndex, 1);
              }
            }
            return true;
          })
          .map(({ icon: Icon, ...i }) => {
            const isSelected = location.pathname === i.path;
            return (
              <div key={i.id}>
                <ListItemButton
                  key={i.id}
                  className="gap-1 mt-2"
                  // onClick={() =>
                  //   i.hasSubsections
                  //     ? setSelected(i.id)
                  //     : handleListItemClick(i.path, i.name)
                  // }
                  onClick={() => {
                    if (i.hasSubsections) {
                      setOpenSubMenus((prev) => ({
                        ...prev,
                        [i.id]: !prev[i.id],
                      }));
                    } else {
                      handleListItemClick(i.path, i.name);
                    }
                  }}
                >
                  <div>
                    {i?.hasSubsections ? (
                      <Down style={{ fontSize: 16, color: "#7E8B99" }} />
                    ) : (
                      <span className="mx-2"></span>
                    )}
                  </div>
                  <ListItemIcon>
                    {i?.noIcon ? (
                      <Icon style={{ color: "#4A545E" }} />
                    ) : (
                      <img src={Icon} alt={i.label} className="sidebar-icon" />
                    )}
                  </ListItemIcon>
                  <Typography
                    className={classNames(
                      isSelected ? "selected-section" : "section-title"
                    )}
                  >
                    {i.name}
                  </Typography>
                </ListItemButton>
                {i?.hasSubsections ? (
                  // <Collapse in={selected === i.id} timeout="auto" unmountOnExit>
                  <Collapse
                    in={openSubMenus[i.id]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding className="mx-2">
                      {i?.subSections?.map(({ SubIcon, ...sub }) => {
                          const issubSelected = location.pathname === sub.path;
                          return (
                            <ListItemButton
                              key={sub.id}
                              sx={{ pl: 10 }}
                              // onClick={() => {
                              //   if (sub?.hasSubsections) {
                              //     if (subListData.length === 0) {
                              //       setSubListData(sub?.subSections || []);
                              //     } else {
                              //       setSubListData([]);
                              //     }
                              //   } else {
                              //     handleListItemClick(sub.path, sub.name);
                              //   }
                              // }}
                              onClick={() => {
                                if (sub?.hasSubsections) {
                                  setOpenSubMenus((prev) => ({
                                    ...prev,
                                    [sub.id]: !prev[sub.id],
                                  }));
                                } else {
                                  handleListItemClick(sub.path, sub.name);
                                }
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  position: "relative",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  {sub?.hasSubsections && (
                                    <Down
                                      style={{
                                        fontSize: 16,
                                        color: "#7E8B99",
                                        position: "absolute",
                                        left: "-12px",
                                      }}
                                    />
                                  )}
                                  <Typography
                                    className={
                                      issubSelected
                                        ? "selected-section"
                                        : "section-title"
                                    }
                                  >
                                    {sub.name}
                                  </Typography>
                                </div>
                                {sub?.hasSubsections && (
                                  <Collapse
                                    // in={subListData.length > 0}
                                    in={openSubMenus[sub.id]}
                                  >
                                    <List component="div" disablePadding>
                                      {sub.subSections.map((subOption) => {
                                        const issubSelected =
                                          location.pathname === subOption.path;
                                        return (
                                          <ListItemButton
                                            key={subOption.id}
                                            onClick={() => {
                                              handleCloseNavMenu();
                                              navigate(subOption?.path);
                                            }}
                                            disabled={subOption?.disabled}
                                          >
                                            <Typography
                                              className={
                                                issubSelected
                                                  ? "selected-section"
                                                  : "section-title"
                                              }
                                            >
                                              {subOption?.name}
                                            </Typography>
                                          </ListItemButton>
                                        );
                                      })}
                                    </List>
                                  </Collapse>
                                )}
                              </div>
                            </ListItemButton>
                          );
                        })}
                    </List>
                  </Collapse>
                ) : null}
              </div>
            );
          })}
      </List>
    </Box>
  );

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElSubNav, setAnchorElSubNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElNotification, setAnchorElNotification] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenNotificationMenu = (event) => {
    setAnchorElNotification(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseNotificationMenu = () => {
    setAnchorElNotification(null);
  };

  const dispatch = useDispatch();
  const [logout, { isLoading }] = useLogoutMutation();
  const [microsoftLogout, { isLoading: microsoftLogoutLoading }] =
    useMicrosoftLogoutMutation();
  const handleCloseUserMenu = async ({ name, path }) => {
    if (name === "Sign Out") {
      try {
        await logout().unwrap();
        dispatch(logOut());
        await microsoftLogout().unwrap();
        return (window.location.href = "/signin");
      } catch (error) {
        console.error("Failed to sign out: ", error);
        return (window.location.href = "/signin");
      }
    }
    setAnchorElUser(null);
    if (name === "Account") {
      return path && navigate(path);
    }
    if (name === "Billing") {
      return path && navigate(path);
    }
    if (name === "User Management") {
      return path && navigate(path);
    }
    if (name === "Role Management") {
      return path && navigate(path);
    }
  };

  return (
    <>
      <Grid className="mx-3">
        <Toolbar disableGutters>
          <Grid
            role="button"
            onClick={() => navigate("/account")}
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
            }}
            className="px-1 align-items-center"
          >
            <img src={Logo} alt="logo" className="logo" />
          </Grid>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={(e) => {
                toggleDrawer(true)(e);
              }}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Drawer
            anchor={"left"}
            open={drawerOpen}
            onClose={toggleDrawer(false)}
          >
            {list()}
          </Drawer>
          <Box
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
            }}
            className="align-items-center"
          >
            <img src={Logo} alt="logo" className="logo" />
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {menuOptionsWithShared
              .filter((option) => option?.access)
              .filter((option) => {
                if (
                  user?.details?.role === 2 &&
                  option.name === "Reporting & Analytics"
                ) {
                  return false;
                }
                if (
                  user?.organisation?.id == 47 &&
                  option.name == "Data Management"
                ) {
                  const caretagsIndex = option.subSections.findIndex(
                    (e) => e?.name === "Caretags"
                  );
                  if (caretagsIndex !== -1) {
                    option.subSections.splice(caretagsIndex, 1);
                  }
                  // const referralSourceIndex = option.subSections.findIndex(
                  //   (e) => e?.name === "Referral Sources"
                  // );
                  // if (referralSourceIndex !== -1) {
                  //   option.subSections.splice(referralSourceIndex, 1);
                  // }
                }
                if (
                  (user?.organisation?.id == 47 ||
                    user?.organisation?.id == 44) &&
                  option.name == "Messenger"
                ) {
                  return true;
                } else if (option.name == "Messenger") {
                  return false;
                }
                return true;
              })
              .map((option, idx) => {
                const Icon = option.icon;
                return (
                  <Button
                    key={option.id}
                    disabled={option?.disabled}
                    onClick={(e) => {
                      if (option?.name === "CareSMS-BI") {
                        redirectToCareSMSBI();
                        return;
                      }
                      setListData(option?.subSections || []);
                      setSubListData([]);
                      option?.subSections
                        ? handleOpenMenu(e)
                        : navigate(option?.path);
                    }}
                    className={[
                      "d-flex my-2 items-center gap-1",
                      location?.pathname === option?.path ||
                      option?.subSections?.some(
                        (sub) => location?.pathname === sub?.path
                      )
                        ? "selected-option"
                        : "normal-option",
                    ].join(" ")}
                  >
                    {option?.noIcon ? (
                      <Icon style={{ color: "#4A545E" }} />
                    ) : (
                      <img
                        src={option?.icon}
                        alt={option.label}
                        className="sidebar-icon"
                      />
                    )}
                    <Typography className="font-14 text-capitalize normal-options">
                      {option?.name}
                    </Typography>
                    {option?.hasSubsections && <DownArrow />}
                  </Button>
                );
              })}
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              style={{ padding: "0px" }}
            >
              {listData
                ?.filter((option) => option?.access)
                ?.filter((sl) => {
                  if (
                    user?.organisation?.data?.isEnterprise &&
                    sl?.isEnterprise === false
                  ) {
                    return false;
                  }
                  return true;
                })
                .map((option) => {
                  return (
                    <>
                      <MenuItem
                        key={option.id}
                        // onClick={(e) => {
                        //   if (option?.hasSubsections) {
                        //     if (subListData.length === 0) {
                        //       setSubListData(option?.subSections || []);
                        //     } else {
                        //       setSubListData([]);
                        //     }
                        //     setAnchorElSubNav(e.currentTarget);
                        //   } else {
                        //     if (option?.name === "CareSMS-BI") {

                        //       redirectToCareSMSBI();
                        //       return;
                        //     }
                        //     handleCloseNavMenu();
                        //     navigate(option?.path);
                        //   }
                        // }}
                        onClick={(e) => {
                          if (option?.hasSubsections) {
                            // Close all other submenus, toggle current one
                            setOpenSubMenus({
                              [option.id]: !openSubMenus[option.id],
                            });

                            // Set submenu items for this menu
                            if (subListData?.menuId !== option.id) {
                              setSubListData({
                                menuId: option.id,
                                items: option.subSections || [],
                              });
                            } else {
                              setSubListData({
                                menuId: option.id,
                                items: subListData.items.length
                                  ? []
                                  : option.subSections || [],
                              });
                            }

                            setAnchorElSubNav(e.currentTarget);
                          } else {
                            if (option?.name === "CareSMS-BI") {
                              redirectToCareSMSBI();
                              return;
                            }
                            handleCloseNavMenu();
                            navigate(option?.path);
                          }
                        }}
                        disabled={option?.disabled}
                        className={[
                          location?.pathname === option?.path
                            ? "selected-option"
                            : "normal-option",
                        ].join(" ")}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div className="-rotate-90">
                              {option?.hasSubsections ? (
                                <Down
                                  style={{ fontSize: 16, color: "#7E8B99" }}
                                />
                              ) : (
                                <span className="mx-2"></span>
                              )}
                            </div>
                            <Typography
                              className="normal-options"
                              textAlign="left"
                            >
                              {option?.name}
                            </Typography>
                          </div>

                          {option?.hasSubsections && (
                            <Collapse in={!!openSubMenus[option.id]}>
                              <List component="div" disablePadding>
                                {(() => {
                                  const filteredSubOptions = (
                                    option?.subSections || []
                                  ).filter((subOption) => subOption?.access);

                                  if (filteredSubOptions.length === 0) {
                                    return (
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          pl: 3,
                                          py: 1,
                                          color: "text.secondary",
                                        }}
                                      >
                                        No option available
                                      </Typography>
                                    );
                                  }

                                  return filteredSubOptions.map((subOption) => (
                                    <ListItemButton
                                      key={subOption.id}
                                      component="div"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleCloseNavMenu();
                                        const path = subOption?.path;
                                        if (path) {
                                          navigate(path);
                                        }
                                      }}
                                      disabled={subOption?.disabled}
                                      className={[
                                        location?.pathname === subOption?.path
                                          ? "selected-option"
                                          : "normal-option",
                                      ].join(" ")}
                                    >
                                      <Typography
                                        className="normal-options"
                                        textAlign="left"
                                      >
                                        {subOption?.name ===
                                          "Upload Scheduling Data" &&
                                        user?.organisation?.data?.isEnterprise
                                          ? "Scheduling Data"
                                          : subOption?.name}
                                      </Typography>
                                    </ListItemButton>
                                  ));
                                })()}
                              </List>
                            </Collapse>
                          )}
                        </div>
                      </MenuItem>
                    </>
                  );
                })}
            </Menu>
          </Box>
          <Box className="d-flex align-items-center" sx={{ flexGrow: 0 }}>
            <Tooltip title="Notifications">
              <IconButton onClick={handleOpenNotificationMenu} className="mx-3">
                <Badge
                  badgeContent={notifications?.filter((f) => !f.isSeen)?.length}
                  color="error"
                >
                  <NotificationsNoneRoundedIcon />
                </Badge>
              </IconButton>
            </Tooltip>
            <NotificationsModal
              anchorEl={anchorElNotification}
              open={Boolean(anchorElNotification)}
              onClose={handleCloseNotificationMenu}
            />
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  src={user?.img}
                  style={{ width: 32, height: 32 }}
                  alt={"user profile"}
                >
                  {avatarName(user.details?.name ?? "")}
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElUser}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {(() => {
                // Only show User Management and Role Management for System Admin
                if (isSystemAdmin(user)) {
                  return settingsCreator
                    .filter((setting) => {
                      // Only show User Management and Role Management for System Admin
                      if (setting.id === 4 || setting.id === 5) {
                        return true;
                      }
                      // Show other settings (Account, Billing, Sign Out) for System Admin
                      if (user?.details?.role === 4 || user?.details?.role === 1) {
                        if (user?.details?.role === 2 && setting.id === 4) {
                          return false;
                        }
                        return true;
                      }
                      return false;
                    })
                    .filter((setting) =>
                      user?.organisation?.data?.isEnterprise
                        ? setting.id !== 3
                        : true
                    );
                }
                // For non-system admins, only show regular settings
                return settings;
              })().map(({ name, id, icon: Icon, path }) => (
                <MenuItem
                  key={id}
                  onClick={() => handleCloseUserMenu({ name, path })}
                >
                  <Icon />
                  <Typography className="mx-2" textAlign="center">
                    {name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
        <Divider />
      </Grid>
    </>
  );
};

export default MenuHeader;
